<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Города
      <span v-if="total">({{ total }})</span>
      <router-link class="btn btn-primary" :to="{ name: 'city-add' }">+ Добавить город</router-link>
    </h1>

    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'settings' }">← Назад к Настройкам</router-link>
    </div>

    <resource-list
      url="/cities"
      current-sort="name"
      init-sort-type="asc"
      resource-name="cities"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'cities',
  components: { resourceList },
  data () {
    return {
      total: null,
      fields: [
        { name: 'name', label: 'Название', sort: true },
        {name: 'districts_count', label: 'Кол-во районов', sort: false}
      ],
      filters: {
        name: ''
      },
      actionRoutes: [
        { name: 'city-details', idName: 'city_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    showMsg (msg, type, title) {
      this.$parent.showPopupMsg(msg, type, title)
    },
    updateTotal (val) {
      this.total = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// Cities.vue?254dcc0b